import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { Subscription } from 'rxjs/internal/Subscription';
import { ApiService } from 'src/app/shared/services/apiService.service';
import { NgxSpinnerService } from "ngx-spinner";
import { secureStorage } from 'src/app/shared/services/encryption/secureservice';
import { ClevertapService } from '../shared/services/clevertap/clevertap.service';
import { isPlatformBrowser } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { SeoService } from '../shared/seo/seo.service';
import { environment } from '../../environments/environment';
import { Router } from '@angular/router';
import { CanonicalService } from '../shared/seo/canonical.service';

declare var $;
@Component({
  selector: 'app-help',
  templateUrl: './help.component.html',
  styleUrls: ['./help.component.scss']
})
export class HelpComponent implements OnInit {
  
  environment1 =environment.s3bucket.url;
  sub: Subscription = new Subscription();
  helpList: any;
  data: any
  currentPage: any = 1;
  totalItems: any = 0;
  itemsPerPage:any = 10;

  breadcrumbdata: any = [];
  showBreadCrumb: boolean = false;
  metatitle = "FAQ - Frequently Asked Questions - Tata Motors Online Sales";
  metadesc = "Frequently Asked Questions - Tata Motors . Know more about Tata Motors vehicles";
  constructor(private apiService: ApiService,private spinner: NgxSpinnerService,
    private localStorage:secureStorage ,private toastrService: ToastrService,
    private cleverService: ClevertapService,@Inject(PLATFORM_ID) private platformId: Object,
    private seoservice: SeoService, private router: Router,
    private canonicalservice: CanonicalService,) { }

  ngOnInit(): void {
    this.canonicalservice.createCanonicalURL('');
    this.seo();
    if (isPlatformBrowser(this.platformId)) {
    $('.header').addClass('p-scroll');
      try {
        this.cleverService.onPageView("Help");
      } catch {}
    }
    this.getHelpList({offset: 0,limit: 10,});
    this.breadcrumb();

  }

  getHelpList(req:any) {
    this.spinner.show()
    this.sub.add(this.apiService.getHelpList(req).subscribe({
      next: (response: any) => {
        if (response["success"]) {
          this.helpList = response["data"];
          this.totalItems = response.range_info.total_count;
          this.spinner.hide()
        }
        else if (!response.success) {
          this.totalItems = 0
          this.toastrService.warning(response.data.msg)
          this.spinner.hide()
        }
      },
      error: () => {
        this.spinner.hide();
        this.toastrService.warning("Something went wrong!")

      },
      complete: () => {
      }
    })
    );

  }

  pageChange(page: any) {
    this.currentPage = page;
    page = page - 1;
    let reqBody =
    {
      "offset": page,
      "limit": 10
    };
    this.getHelpList(reqBody)
  }
  breadcrumb()
  {
    if (isPlatformBrowser(this.platformId)) {
    localStorage.removeItem('localBreadCrumb');
    this.breadcrumbdata =[];
    var breadcrumbList1 = {
      label: 'Help',
      url: `/Help/`
    };
    this.breadcrumbdata.push(breadcrumbList1);
    this.localStorage.setItem('localBreadCrumb', JSON.stringify(this.breadcrumbdata));
    this.showBreadCrumb = true;
  }
  }
  seo() {
    this.seoservice.updateTitle(this.metatitle);
    this.seoservice.updateMetaTag("description", null, this.metadesc);
    this.seoservice.updateMetaTag(null, "og:locale", "en_US");
    this.seoservice.updateMetaTag(null, "og:type", "Website");
    this.seoservice.updateMetaTag(
      null,
      "og:title",
      this.metatitle
    );
    this.seoservice.updateMetaTag(null, "og:description", this.metadesc);
    this.seoservice.updateMetaTag(null, "og:url", environment.baseUrl + this.router.url);
    this.seoservice.updateMetaTag(null, "og:site_name", "Tata OSP");
  }
}


